import React, { useEffect } from 'react';

function Verify() {
  useEffect(() => {
    document.title = 'Verification | Izzie Fox - Independent UK Adult Content Creator';
  }, []);
  return (
    <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #FAF8FB 0%, #FFFFFF 50%, #F5F0F6 100%)'}} onContextMenu={(e) => { if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') e.preventDefault(); }}>
      <style>{`
        img, video {
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          -webkit-user-drag: none;
          -webkit-touch-callout: none;
        }
        .watermark-container {
          position: relative;
          overflow: hidden;
        }
        .watermark-container::after {
          content: 'Izzie Fox | izziefox.co.uk';
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          color: rgba(255, 255, 255, 0.5);
          font-size: 28px;
          font-weight: 800;
          letter-spacing: 3px;
          text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.7);
          pointer-events: none;
          z-index: 10;
          white-space: nowrap;
        }
      `}</style>
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b" style={{borderColor: '#EBBEDA'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <a href="/" className="text-2xl font-bold" style={{color: '#EBBEDA'}}>
              Izzie Fox
            </a>
            <a 
              href="/" 
              className="text-gray-700 hover:text-pink-400 transition-colors font-medium"
            >
              ← Back to Home
            </a>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-3xl mx-auto text-center">
          {/* Header */}
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-6" style={{background: '#EBBEDA'}}>
              <span className="text-4xl">✓</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              <span style={{color: '#EBBEDA'}}>Verification</span>
            </h1>
            <p className="text-gray-600 text-lg max-w-xl mx-auto">
              Hey! This video confirms that my profile is authentic so you can feel confident you're connecting with the real me.
            </p>
          </div>

          {/* Video Container */}
          <div className="bg-white rounded-3xl shadow-xl p-6 md:p-8 mb-8" style={{borderTop: '4px solid #EBBEDA'}}>
            <div className="watermark-container rounded-2xl">
              <video 
                controls 
                className="w-full rounded-2xl shadow-lg"
                style={{maxHeight: '500px'}}
                poster=""
                data-testid="verification-video"
              >
                <source 
                  src="https://customer-assets-cm19k8pv.emergentagent.net/job_5c894e6e-0304-492d-914b-8cdb66b97bf0/artifacts/gprnheoo_copy_DAD978B3-239A-4CEF-B378-FD696215B6E7.mov" 
                  type="video/mp4" 
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          {/* Official Platforms */}
          <div className="bg-white rounded-3xl shadow-xl p-6 md:p-8 mb-8" style={{borderTop: '4px solid #EBBEDA'}} data-testid="official-platforms-section">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">My <span style={{color: '#EBBEDA'}}>Official Platforms</span></h2>
            <p className="text-gray-500 text-sm mb-6">These are the only accounts that belong to me. If it's not listed here, it's not me.</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <a href="https://onlyfans.com/izziefox1" target="_blank" rel="noopener noreferrer" data-testid="platform-onlyfans"
                className="flex flex-col items-center gap-2 p-4 rounded-2xl border-2 transition-all hover:scale-105 hover:shadow-md relative"
                style={{borderColor: '#EBBEDA'}}>
                <span className="absolute -top-2 -right-2 text-white text-xs font-bold px-2 py-0.5 rounded-full shadow" style={{background: '#EBBEDA'}}>FREE</span>
                <svg className="w-8 h-8" style={{color: '#00AFF0'}} fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 17.07c-1.465 1.375-3.455 2.18-5.596 2.18-2.22 0-4.17-.734-5.636-2.18C5.197 15.696 4.5 13.934 4.5 12c0-1.934.697-3.696 2.162-5.07C8.128 5.555 10.078 4.75 12.298 4.75c2.14 0 4.13.805 5.596 2.18C19.36 8.304 20 10.066 20 12c0 1.934-.64 3.696-2.106 5.07zM12 7.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/></svg>
                <span className="font-semibold text-gray-800 text-sm">OnlyFans</span>
                <span className="text-xs text-gray-500">@izziefox1</span>
              </a>
              <a href="https://www.instagram.com/izzieefoxx/" target="_blank" rel="noopener noreferrer" data-testid="platform-instagram"
                className="flex flex-col items-center gap-2 p-4 rounded-2xl border-2 transition-all hover:scale-105 hover:shadow-md"
                style={{borderColor: '#EBBEDA'}}>
                <svg className="w-8 h-8" style={{color: '#E1306C'}} fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                <span className="font-semibold text-gray-800 text-sm">Instagram</span>
                <span className="text-xs text-gray-500">@izzieefoxx</span>
              </a>
              <a href="https://x.com/izzieefox" target="_blank" rel="noopener noreferrer" data-testid="platform-x"
                className="flex flex-col items-center gap-2 p-4 rounded-2xl border-2 transition-all hover:scale-105 hover:shadow-md"
                style={{borderColor: '#EBBEDA'}}>
                <svg className="w-8 h-8" style={{color: '#000'}} fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                <span className="font-semibold text-gray-800 text-sm">X (Twitter)</span>
                <span className="text-xs text-gray-500">@izzieefox</span>
              </a>
              <a href="https://t.me/izziefoxx" target="_blank" rel="noopener noreferrer" data-testid="platform-telegram"
                className="flex flex-col items-center gap-2 p-4 rounded-2xl border-2 transition-all hover:scale-105 hover:shadow-md"
                style={{borderColor: '#EBBEDA'}}>
                <svg className="w-8 h-8" style={{color: '#0088cc'}} fill="currentColor" viewBox="0 0 24 24"><path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
                <span className="font-semibold text-gray-800 text-sm">Telegram</span>
                <span className="text-xs text-gray-500">@izziefoxx</span>
              </a>
            </div>
          </div>

          {/* Trust Badges */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            <div className="bg-white rounded-2xl p-5 shadow-lg">
              <div className="text-3xl mb-2">🔒</div>
              <h3 className="font-bold text-gray-800">100% Real</h3>
              <p className="text-gray-600 text-sm">Verified authentic person</p>
            </div>
            <div className="bg-white rounded-2xl p-5 shadow-lg">
              <div className="text-3xl mb-2">💬</div>
              <h3 className="font-bold text-gray-800">Direct Contact</h3>
              <p className="text-gray-600 text-sm">You talk directly to me</p>
            </div>
            <div className="bg-white rounded-2xl p-5 shadow-lg">
              <div className="text-3xl mb-2">🤫</div>
              <h3 className="font-bold text-gray-800">Discreet</h3>
              <p className="text-gray-600 text-sm">Your privacy is protected</p>
            </div>
          </div>

          {/* CTA */}
          <div className="space-y-4">
            <a 
              href="https://wa.me/447386375420"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 text-white font-bold text-lg rounded-full transition-all hover:scale-105 shadow-lg"
              style={{background: '#25D366'}}
              data-testid="verify-whatsapp-btn"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Message Me on WhatsApp
            </a>
            <p className="text-gray-500 text-sm">
              Ready to connect? Let's chat!
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t py-6 text-center" style={{borderColor: '#EBBEDA'}}>
        <p className="text-gray-500 text-sm">
          © 2026 Izzie Fox. All rights reserved. | 18+ Only
        </p>
      </footer>
    </div>
  );
}

export default Verify;
